import styled from 'styled-components';
import { mediaMax } from 'themes/helpers';

export const Container = styled.div`
  max-width: ${({ width }) => (width && width) || '1240px'};
  padding: 0 30px;
  margin: 0 auto;
  position: relative;
  z-index: 2;

  ${mediaMax.phoneL`
    padding: 0 1rem;
  `}
`;

export const StyledFooter = styled.footer`
  padding: 40px 0;
  background-color: black;

  span.bullet {
    width: 5px
    height: 5px;
    display: inline-block;
    border-radius: 100%;
    background-color: #53FF66;
    margin: 0 6px;
  }

  .grid {
    font-family: 'Jost', sans-serif;
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    .divider {
      width: 100%;
      height: 1px;
      background-color: #E8E8E8
      grid-column: 1 / -1;
      opacity: 0.4;
      margin: 1rem 0;
    }

    .upper-left {
      display: flex;
      align-items: center;
      gap: 1rem;

      img {
        width: 50px;
        height: 50px;
      }
      > p {
        font-size: 1rem;
        display: flex;
        align-items: center;
        white-space: nowrap;

        &.mobile {
          display: none;
        }

        img {
          width: 20px;
          height: 20px;
        }
      }
    }

    .upper-right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 1rem;

      > small {
        font-size: 1rem;
      }

      .media {
        display: flex;
        align-items: center;
        gap: 1rem;
      }
      > button {
        font-size: 1rem;
        color: #53FF66;
        font-weight: bold;
        cursor: pointer;
      }
    }
    .lower-left {
      display: flex;
      align-items: center;
      white-space: nowrap;

      > span {
        font-size: 1rem;
        font-weight: 300;
        > a {
          color: #53FF66;
        }
      }
      a {
        color: white;
        font-size: 1rem;
        font-weight: 300;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .lower-right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 1rem;

      > p {
        font-size: 1rem;
        > span {
          color: #53FF66;
        }
      }
    }
  }

  ${mediaMax.phoneL`
    padding: 20px 0;
    .grid {
      grid-template-columns: 1fr;

      .divider {
        width: 22%;
        margin: 1rem auto;
      }

      .upper-left {
        justify-content: center;
        > img {
          width: 38px;
          height: 38px;
        }
        > p {
          &.desktop {
            display: none;
          }
          &.mobile {
            display: flex;
          }
          span.extend {
            display: none;
          }
        }
      }
      .upper-right {
        flex-direction: column;
        .media {
          width: 100%;
          justify-content: space-around;
          flex-wrap: wrap;
          a > img {
            width: 30px;
            height: 30px;
          }
        }
      }
      .lower-left {
        justify-content: center;
        flex-wrap: wrap;
        > a, > span {
          font-size: 0.85rem;
        }
      }
      .lower-right {
        margin-top: 1rem;
        text-align: center;
        > p {
          font-size: 0.85rem;
        }
      }
    }
  `};
`;



// WEBPACK FOOTER //
// ./src/components/Footer/styles.js